import { Subscription } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { faBan, faCheck } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-exercise-list',
  templateUrl: './exercise-list.component.html',
  styleUrls: ['./exercise-list.component.scss']
})
export class ExerciseListComponent extends BaseList implements OnInit, OnDestroy {

  protected rightLoad = 'admin.exercise.list';
  protected rightNew = 'admin.exercise.create';
  protected rightOpen = 'admin.exercise.show';

  protected apiUrl = '/exercises';

  public allExercises: Array<ExerciseModel> = [];
  public exercises: Array<ExerciseModel> = [];
  public subscriptions: Array<Subscription> = [];

  public form = this.fb.group({
    show_inactive: new UntypedFormControl(localStorage.getItem('exercise-list-show-inactive') === 'true')
  });

  public faCheck = faCheck;
  public faBan = faBan;

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    private fb: UntypedFormBuilder,
    protected transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.exercises'));
    this.loadList();
    this.subscriptions.push(this.form.get('show_inactive').valueChanges.subscribe((value: boolean) => {
      localStorage.setItem('exercise-list-show-inactive', value.toString());
      this.setListData();
    }));
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('exercises').subscribe({
      next: (exercises: any) => {
        this.allExercises = [];
        exercises.data.forEach((exercise: any) => {
          this.allExercises.push(new ExerciseModel().deserialize(exercise));
        });
        this.setListData();
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

  private setListData(): void {
    this.exercises = this.allExercises.filter((exercise: ExerciseModel) => {
      return this.form.get('show_inactive').value === true || exercise.status === 'active';
    });
  }

}
